import { render, staticRenderFns } from "./ActiveBtn.vue?vue&type=template&id=8908bdec&"
import script from "./ActiveBtn.vue?vue&type=script&lang=js&"
export * from "./ActiveBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports